/** 超出此长度时在时间线中显示展开/收起，并与截断预览对齐 */
export const PROMPT_COLLAPSE_THRESHOLD = 140

export function shortenPrompt(text: string): string {
  const normalized = text.trim()
  if (normalized.length <= PROMPT_COLLAPSE_THRESHOLD) return normalized
  return `${normalized.slice(0, PROMPT_COLLAPSE_THRESHOLD)}…`
}

/** 服务端/演示若误把全文塞进 promptPreview，则仍按阈值截断，避免收起态与全文一致 */
export function collapsedTimelinePrompt(round: {
  prompt: string
  promptPreview?: string
}): string {
  const full = round.prompt.trim()
  const preview = round.promptPreview?.trim()
  if (preview && preview !== full) return preview
  return shortenPrompt(round.prompt)
}
